import { render } from "./dcr.vue?vue&type=template&id=936e43e6"
import script from "./dcr.vue?vue&type=script&lang=js"
export * from "./dcr.vue?vue&type=script&lang=js"

import exportComponent from "/home/code/aiyu-before-pc/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__